<button
  type="button"
  mat-menu-item
  class="actions-menu__item"
  [class.is-selected]="selectedOption === CostFileTicketPartsMenuEnum.On"
  (click)="setOn()"
  *ngIf="selectedOption !== CostFileTicketPartsMenuEnum.Off">
  On
</button>
<button
  type="button"
  mat-menu-item
  class="actions-menu__item"
  [class.is-selected]="selectedOption === CostFileTicketPartsMenuEnum.Off"
  (click)="setOff()">
  Off
</button>
<button type="button" mat-menu-item class="actions-menu__item" (click)="setup()">Setup</button>
